import React, { PureComponent } from "react";

import styles from "./Dashboard.local.scss";
import classnames from "classnames";
import _ from "i18n";
import { TTP_ACCOUNTING_URL } from "Config";

export default class DashboardComponent extends PureComponent {
  state = {
    iframeType: "DASHBOARD"
  };

  render() {
    const { id, uen } = this.props.community;
    const { iframeType } = this.state;

    const iframeSrc =
      iframeType === "DASHBOARD"
        ? `${TTP_ACCOUNTING_URL}/embed/dashboard/${uen}/4?organization_id=${id}`
        : `${TTP_ACCOUNTING_URL}/embed/balance-sheet/${uen}?organization_id=${id}`;

    return (
      <div className={styles.dahsboard}>
        <div className={styles.header}>
          <ul id="dashboard-choices">
            <li
              className={iframeType === "DASHBOARD" ? styles.activated : ""}
              onClick={() => {
                this.setState({ iframeType: "DASHBOARD" });
              }}
            >
              {_("Dashboard")}
            </li>
            <li
              className={iframeType === "TABLE" ? styles.activated : ""}
              onClick={() => {
                this.setState({ iframeType: "TABLE" });
              }}
            >
              {_("Table")}
            </li>
          </ul>
          <i
            className={classnames("icon icon-options-vertical", styles.points)}
          />
        </div>

        <div
          className={classnames(
            styles.details,
            styles[iframeType.toLowerCase()]
          )}
        >
          <div className={styles.iframeContainer}>
            <iframe src={iframeSrc} title="dashboard" id="dashboard-iframe" />
          </div>
        </div>
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/ClientSpace/Dashboard/DashboardComponent.js